var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Box, Typography, useMediaQuery } from "@mui/material";
import dayjs from "dayjs";
import { ReactComponent as CalanderIconSVG } from "../../../assets/images/calendarIcon.svg";
import { ReactComponent as CloseIcon } from '../../../assets/images/closeIcon.svg';
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { useAppSelector } from "../../../store/hooks";
import { dateFormate } from "../../../utils/utils";
import { vehicleHistoryKeys } from "../service/entity";
import { LabourDetails } from "./labourDetails";
import { labourElements, partElements } from "./labourPartColumns";
import { PartDetails } from "./partDetails";
import { useState } from "react";
import { ReactComponent as DropDownIconNew } from '../../../assets/images/downArrow.svg';
import { ReactComponent as VerifiedIcon } from '../../../assets/images/check-verified.svg';
import { ReactComponent as MailIcon } from '../../../assets/images/mailSvg.svg';
import { ReactComponent as LocationIcon } from '../../../assets/images/LocationIcon.svg';
import { ReactComponent as NewUpArrow } from '../../../assets/images/newUpArrow.svg';
import { useParams } from "react-router-dom";
import { fetchNpsByChassis } from "../service/apiCall";
import NpsChip from "../../../components/molecules/NPSChip";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { LOCAL_STORAGE_KEYS } from "../../../constants";
export var ViewServiceHistory = function (_ref) {
    var _crud$vehicleHistoryK, _crud$vehicleHistoryK2, _crud$vehicleHistoryK3, _crud$vehicleHistoryK4, _crud$vehicleHistoryK5, _crud$vehicleHistoryK6, _crud$vehicleHistoryK7, _crud$vehicleHistoryK8, _crud$vehicleHistoryK9, _crud$vehicleHistoryK10, _crud$vehicleHistoryK11, _crud$vehicleHistoryK12, _crud$vehicleHistoryK13, _crud$vehicleHistoryK14, _crud$vehicleHistoryK15, _crud$vehicleHistoryK16, _crud$vehicleHistoryK17, _crud$vehicleHistoryK18, _crud$vehicleHistoryK19, _crud$vehicleHistoryK20, _crud$vehicleHistoryK23, _crud$vehicleHistoryK24, _crud$vehicleHistoryK25, _crud$vehicleHistoryK26, _crud$vehicleHistoryK27, _crud$vehicleHistoryK28, _crud$vehicleHistoryK29, _crud$vehicleHistoryK30, _crud$vehicleHistoryK31, _crud$vehicleHistoryK32, _crud$vehicleHistoryK33, _crud$vehicleHistoryK34, _crud$vehicleHistoryK35, _crud$vehicleHistoryK36, _crud$vehicleHistoryK37, _crud$vehicleHistoryK38, _crud$vehicleHistoryK39, _crud$vehicleHistoryK40, _crud$vehicleHistoryK41, _crud$vehicleHistoryK42, _crud$vehicleHistoryK43, _crud$vehicleHistoryK44, _crud$vehicleHistoryK45, _crud$vehicleHistoryK46;
    var onClose = _ref.onClose, data = _ref.data, isFromQuickLink = _ref.isFromQuickLink;
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var crud = useAppSelector(function (state) { return state.crud; });
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var SELECTED_CHANNEL = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_CHANNEL);
    var crudDataForPart = (_crud$vehicleHistoryK = crud[vehicleHistoryKeys.SeviceHistoryKey]) === null || _crud$vehicleHistoryK === void 0 || (_crud$vehicleHistoryK = _crud$vehicleHistoryK.data) === null || _crud$vehicleHistoryK === void 0 ? void 0 : _crud$vehicleHistoryK.JCSpare;
    var crudDataForLabour = (_crud$vehicleHistoryK2 = crud[vehicleHistoryKeys.SeviceHistoryKey]) === null || _crud$vehicleHistoryK2 === void 0 || (_crud$vehicleHistoryK2 = _crud$vehicleHistoryK2.data) === null || _crud$vehicleHistoryK2 === void 0 ? void 0 : _crud$vehicleHistoryK2.JCLabour;
    var crudDataForComplaints = (_crud$vehicleHistoryK3 = crud[vehicleHistoryKeys.SeviceHistoryKey]) === null || _crud$vehicleHistoryK3 === void 0 || (_crud$vehicleHistoryK3 = _crud$vehicleHistoryK3.data) === null || _crud$vehicleHistoryK3 === void 0 ? void 0 : _crud$vehicleHistoryK3.Complaints;
    var id = useParams().id;
    var ViewServiceHistoryDetails = [{
            type: FormItemTypes.ContainerItem,
            name: 'ViewVehicleHistory',
            columnSize: 12,
            padding: '20px 24px 20px 24px',
            flexDirection: 'row',
            justifyContent: 'space-between',
            elements: [{
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    flexDirection: 'column',
                    columnSize: 10,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'vehicleName',
                            value: "".concat(data === null || data === void 0 ? void 0 : data.JobCard, " - details"),
                            fontWeight: 'strong',
                            fontSize: 'xxl',
                            columnSize: true
                        }]
                }, {
                    type: FormItemTypes.IconButton,
                    name: '',
                    children: /*#__PURE__*/ React.createElement(CloseIcon, {
                        color: "text.secondary",
                        height: '12px',
                        width: '12px'
                    }),
                    columnSize: 0,
                    onClick: function () {
                        onClose(false);
                    },
                    sx: {
                        padding: '12px'
                    }
                }]
        }, {
            type: FormItemTypes.Divider,
            name: 'divider',
            variant: "fullWidth",
            columnSize: 12
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            border: '1px solid',
            borderColor: 'secondary.200',
            borderRadius: '12px',
            sx: {
                margin: '20px 24px 20px 24px'
            },
            hidden: isFromQuickLink,
            elements: [{
                    type: FormItemTypes.CardComponent,
                    name: '',
                    columnSize: 12,
                    sx: {
                        border: '1px',
                        borderRadius: "12px",
                        borderColor: "red"
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: true,
                            fontWeight: "strong",
                            children: 'Basic details',
                            color: "secondary.900"
                        }, {
                            type: FormItemTypes.IconButton,
                            name: ' basic-dropdown-icon',
                            columnSize: 0,
                            children: isOpen ? /*#__PURE__*/ React.createElement(NewUpArrow, null) : /*#__PURE__*/ React.createElement(DropDownIconNew, null),
                            setFormState: function (formValues, currValue) {
                                if (isOpen) {
                                    setIsOpen(false);
                                }
                                else {
                                    setIsOpen(true);
                                }
                                return {};
                            }
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            spacing: 0,
                            rowGap: 1,
                            columnSpacing: 2,
                            alignItems: 'start',
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    xs: 12,
                                    sm: 6,
                                    md: 6,
                                    lg: 6,
                                    spacing: 0,
                                    rowGap: 1,
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            children: 'Customer details',
                                            fontSize: 'sm',
                                            fontWeight: 'medium',
                                            color: 'text.secondary',
                                            columnSize: 12
                                        }, !isOpen ? {
                                            type: FormItemTypes.CardComponent,
                                            name: '',
                                            // sx: { p: 1.5 },
                                            sx: {
                                                padding: {
                                                    xs: 1.5
                                                }
                                            },
                                            columnSize: 12,
                                            contentProps: {
                                                spacing: 0
                                            },
                                            elements: [{
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    columnSize: 0,
                                                    spacing: 0,
                                                    columnGap: 1,
                                                    alignItems: 'center',
                                                    flexWrap: 'nowrap',
                                                    display: 'flex',
                                                    justifyContent: "space-between",
                                                    elements: [{
                                                            type: FormItemTypes.Box,
                                                            name: '',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: "center",
                                                            columnSize: 0,
                                                            gap: 1,
                                                            elements: [{
                                                                    type: FormItemTypes.Avatar,
                                                                    name: '',
                                                                    columnSize: 0,
                                                                    sx: {
                                                                        height: 24,
                                                                        width: 24
                                                                    }
                                                                }, {
                                                                    type: FormItemTypes.Typography,
                                                                    name: 'GivenNameAndFamilyName',
                                                                    value: "".concat((_crud$vehicleHistoryK4 = (_crud$vehicleHistoryK5 = crud[vehicleHistoryKeys.CustomerDetailsKey]) === null || _crud$vehicleHistoryK5 === void 0 || (_crud$vehicleHistoryK5 = _crud$vehicleHistoryK5.data) === null || _crud$vehicleHistoryK5 === void 0 || (_crud$vehicleHistoryK5 = _crud$vehicleHistoryK5.Person) === null || _crud$vehicleHistoryK5 === void 0 ? void 0 : _crud$vehicleHistoryK5.GivenName) !== null && _crud$vehicleHistoryK4 !== void 0 ? _crud$vehicleHistoryK4 : '-', " ").concat((_crud$vehicleHistoryK6 = (_crud$vehicleHistoryK7 = crud[vehicleHistoryKeys.CustomerDetailsKey]) === null || _crud$vehicleHistoryK7 === void 0 || (_crud$vehicleHistoryK7 = _crud$vehicleHistoryK7.data) === null || _crud$vehicleHistoryK7 === void 0 || (_crud$vehicleHistoryK7 = _crud$vehicleHistoryK7.Person) === null || _crud$vehicleHistoryK7 === void 0 ? void 0 : _crud$vehicleHistoryK7.FamilyName) !== null && _crud$vehicleHistoryK6 !== void 0 ? _crud$vehicleHistoryK6 : ' '),
                                                                    columnSize: 0,
                                                                    fontWeight: 'medium',
                                                                    fontSize: 'base'
                                                                }]
                                                        }, {
                                                            type: FormItemTypes.Box,
                                                            name: '',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: "center",
                                                            textAlign: 'center',
                                                            columnSize: 0,
                                                            justifyItems: 'center',
                                                            gap: 1,
                                                            elements: [{
                                                                    type: FormItemTypes.Typography,
                                                                    name: 'PrimaryMobileNo',
                                                                    columnSize: true,
                                                                    value: "".concat((_crud$vehicleHistoryK8 = (_crud$vehicleHistoryK9 = crud[vehicleHistoryKeys.CustomerDetailsKey]) === null || _crud$vehicleHistoryK9 === void 0 || (_crud$vehicleHistoryK9 = _crud$vehicleHistoryK9.data) === null || _crud$vehicleHistoryK9 === void 0 || (_crud$vehicleHistoryK9 = _crud$vehicleHistoryK9.PersonContactPoint[1]) === null || _crud$vehicleHistoryK9 === void 0 ? void 0 : _crud$vehicleHistoryK9.MobileNumber) !== null && _crud$vehicleHistoryK8 !== void 0 ? _crud$vehicleHistoryK8 : '-'),
                                                                    fontSize: "sm",
                                                                    color: 'text.secondary'
                                                                }, {
                                                                    type: FormItemTypes.Icon,
                                                                    name: 'verified-icon',
                                                                    children: ((_crud$vehicleHistoryK10 = crud[vehicleHistoryKeys.CustomerDetailsKey]) === null || _crud$vehicleHistoryK10 === void 0 || (_crud$vehicleHistoryK10 = _crud$vehicleHistoryK10.data) === null || _crud$vehicleHistoryK10 === void 0 || (_crud$vehicleHistoryK10 = _crud$vehicleHistoryK10.PersonContactPoint[1]) === null || _crud$vehicleHistoryK10 === void 0 ? void 0 : _crud$vehicleHistoryK10.IsMobileVerified) == true ? /*#__PURE__*/ React.createElement(VerifiedIcon, {
                                                                        height: 15,
                                                                        width: 15
                                                                    }) : undefined,
                                                                    columnSize: 0,
                                                                    sx: {
                                                                        color: 'info.500',
                                                                        p: 0,
                                                                        mt: '6px',
                                                                        alignItems: 'center',
                                                                        marginBottom: '-7px'
                                                                    }
                                                                }]
                                                        }]
                                                }]
                                        } : null, isOpen ? {
                                            type: FormItemTypes.CardComponent,
                                            name: '',
                                            columnSize: 12,
                                            contentProps: {
                                                spacing: 0,
                                                gap: '8px'
                                            },
                                            elements: [{
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    columnSize: 12,
                                                    spacing: 0,
                                                    columnGap: 1,
                                                    rowGap: 1,
                                                    // justifyContent: 'space-between',
                                                    elements: [{
                                                            type: FormItemTypes.Avatar,
                                                            name: 'vh-profile-icon',
                                                            columnSize: 0
                                                        }, {
                                                            type: FormItemTypes.ContainerItem,
                                                            name: '',
                                                            // columnSize: 8.5,
                                                            columnSize: true,
                                                            spacing: 0,
                                                            // gap: '4px',s
                                                            columnSpacing: 0.5,
                                                            elements: [{
                                                                    type: FormItemTypes.Typography,
                                                                    name: 'FamilyNameAndGivenName',
                                                                    value: "".concat((_crud$vehicleHistoryK11 = (_crud$vehicleHistoryK12 = crud[vehicleHistoryKeys.CustomerDetailsKey]) === null || _crud$vehicleHistoryK12 === void 0 || (_crud$vehicleHistoryK12 = _crud$vehicleHistoryK12.data) === null || _crud$vehicleHistoryK12 === void 0 || (_crud$vehicleHistoryK12 = _crud$vehicleHistoryK12.Person) === null || _crud$vehicleHistoryK12 === void 0 ? void 0 : _crud$vehicleHistoryK12.GivenName) !== null && _crud$vehicleHistoryK11 !== void 0 ? _crud$vehicleHistoryK11 : '-', " ").concat((_crud$vehicleHistoryK13 = (_crud$vehicleHistoryK14 = crud[vehicleHistoryKeys.CustomerDetailsKey]) === null || _crud$vehicleHistoryK14 === void 0 || (_crud$vehicleHistoryK14 = _crud$vehicleHistoryK14.data) === null || _crud$vehicleHistoryK14 === void 0 || (_crud$vehicleHistoryK14 = _crud$vehicleHistoryK14.Person) === null || _crud$vehicleHistoryK14 === void 0 ? void 0 : _crud$vehicleHistoryK14.FamilyName) !== null && _crud$vehicleHistoryK13 !== void 0 ? _crud$vehicleHistoryK13 : ' '),
                                                                    columnSize: 12,
                                                                    fontWeight: 'medium',
                                                                    fontSize: 'base',
                                                                    color: 'text.primary',
                                                                    display: 'flex',
                                                                    flexDirection: 'row'
                                                                }, {
                                                                    type: FormItemTypes.ContainerItem,
                                                                    name: '',
                                                                    columnSize: 12,
                                                                    spacing: 0,
                                                                    gap: '4px',
                                                                    elements: [{
                                                                            type: FormItemTypes.Typography,
                                                                            name: 'MobileNoPrimary',
                                                                            value: "".concat((_crud$vehicleHistoryK15 = (_crud$vehicleHistoryK16 = crud[vehicleHistoryKeys.CustomerDetailsKey]) === null || _crud$vehicleHistoryK16 === void 0 || (_crud$vehicleHistoryK16 = _crud$vehicleHistoryK16.data) === null || _crud$vehicleHistoryK16 === void 0 || (_crud$vehicleHistoryK16 = _crud$vehicleHistoryK16.PersonContactPoint[1]) === null || _crud$vehicleHistoryK16 === void 0 ? void 0 : _crud$vehicleHistoryK16.MobileNumber) !== null && _crud$vehicleHistoryK15 !== void 0 ? _crud$vehicleHistoryK15 : '-'),
                                                                            containerProps: {
                                                                                spacing: 0
                                                                            },
                                                                            columnSize: 0,
                                                                            color: 'secondary.500',
                                                                            fontSize: 'sm'
                                                                        }, {
                                                                            type: FormItemTypes.Icon,
                                                                            name: 'IsVerified',
                                                                            children: ((_crud$vehicleHistoryK17 = crud[vehicleHistoryKeys.CustomerDetailsKey]) === null || _crud$vehicleHistoryK17 === void 0 || (_crud$vehicleHistoryK17 = _crud$vehicleHistoryK17.data) === null || _crud$vehicleHistoryK17 === void 0 || (_crud$vehicleHistoryK17 = _crud$vehicleHistoryK17.PersonContactPoint[1]) === null || _crud$vehicleHistoryK17 === void 0 ? void 0 : _crud$vehicleHistoryK17.IsMobileVerified) == true ? /*#__PURE__*/ React.createElement(VerifiedIcon, {
                                                                                height: 18,
                                                                                width: 18
                                                                            }) : undefined,
                                                                            columnSize: 0,
                                                                            sx: {
                                                                                color: 'info.500',
                                                                                p: 0,
                                                                                mt: '2px',
                                                                                pb: '6px',
                                                                                alignItems: 'center',
                                                                                display: ((_crud$vehicleHistoryK18 = crud[vehicleHistoryKeys.CustomerDetailsKey]) === null || _crud$vehicleHistoryK18 === void 0 || (_crud$vehicleHistoryK18 = _crud$vehicleHistoryK18.data) === null || _crud$vehicleHistoryK18 === void 0 || (_crud$vehicleHistoryK18 = _crud$vehicleHistoryK18.PersonContactPoint[1]) === null || _crud$vehicleHistoryK18 === void 0 ? void 0 : _crud$vehicleHistoryK18.IsMobileVerified) == true ? 'inline-flex' : 'none'
                                                                            }
                                                                        }, {
                                                                            type: FormItemTypes.Divider,
                                                                            name: 'verticalDivider',
                                                                            variant: 'fullWidth',
                                                                            orientation: 'vertical',
                                                                            columnSize: 0,
                                                                            sx: {
                                                                                mt: "2px",
                                                                                height: '15px'
                                                                            }
                                                                        }, {
                                                                            type: FormItemTypes.Typography,
                                                                            name: 'MobileNoSecondary',
                                                                            value: "".concat((_crud$vehicleHistoryK19 = (_crud$vehicleHistoryK20 = crud[vehicleHistoryKeys.CustomerDetailsKey]) === null || _crud$vehicleHistoryK20 === void 0 || (_crud$vehicleHistoryK20 = _crud$vehicleHistoryK20.data) === null || _crud$vehicleHistoryK20 === void 0 || (_crud$vehicleHistoryK20 = _crud$vehicleHistoryK20.PersonContactPoint[0]) === null || _crud$vehicleHistoryK20 === void 0 ? void 0 : _crud$vehicleHistoryK20.MobileNumber) !== null && _crud$vehicleHistoryK19 !== void 0 ? _crud$vehicleHistoryK19 : '-'),
                                                                            columnSize: 0,
                                                                            color: 'secondary.500',
                                                                            fontSize: 'sm',
                                                                            paddingLeft: '10px',
                                                                            valueGetter: function (formValues, field) {
                                                                                var _crud$vehicleHistoryK21;
                                                                                var mobileNumber = (_crud$vehicleHistoryK21 = crud[vehicleHistoryKeys.CustomerDetailsKey]) === null || _crud$vehicleHistoryK21 === void 0 || (_crud$vehicleHistoryK21 = _crud$vehicleHistoryK21.data) === null || _crud$vehicleHistoryK21 === void 0 || (_crud$vehicleHistoryK21 = _crud$vehicleHistoryK21.PersonContactPoint) === null || _crud$vehicleHistoryK21 === void 0 || (_crud$vehicleHistoryK21 = _crud$vehicleHistoryK21[0]) === null || _crud$vehicleHistoryK21 === void 0 ? void 0 : _crud$vehicleHistoryK21.MobileNumber;
                                                                                return mobileNumber !== '0000000000' ? mobileNumber : '-';
                                                                            }
                                                                        }, {
                                                                            type: FormItemTypes.Icon,
                                                                            name: 'IsVerifiedSecondaryNo',
                                                                            // children: crud[vehicleHistoryKeys.CustomerDetailsKey]?.data?.PersonContactPoint[0]?.IsMobileVerified == true ? <VerifiedIcon height={15} width={15} /> : undefined,
                                                                            children: (function (_crud$vehicleHistoryK22) {
                                                                                var personContact = (_crud$vehicleHistoryK22 = crud[vehicleHistoryKeys.CustomerDetailsKey]) === null || _crud$vehicleHistoryK22 === void 0 || (_crud$vehicleHistoryK22 = _crud$vehicleHistoryK22.data) === null || _crud$vehicleHistoryK22 === void 0 || (_crud$vehicleHistoryK22 = _crud$vehicleHistoryK22.PersonContactPoint) === null || _crud$vehicleHistoryK22 === void 0 ? void 0 : _crud$vehicleHistoryK22[0];
                                                                                var mobileNumber = personContact === null || personContact === void 0 ? void 0 : personContact.MobileNumber;
                                                                                var isVerified = personContact === null || personContact === void 0 ? void 0 : personContact.IsMobileVerified;
                                                                                return mobileNumber && mobileNumber !== '0000000000' && isVerified === true ? /*#__PURE__*/ React.createElement(VerifiedIcon, {
                                                                                    height: 15,
                                                                                    width: 15
                                                                                }) : undefined;
                                                                            })(),
                                                                            columnSize: 0,
                                                                            sx: {
                                                                                color: 'info.500',
                                                                                p: 0,
                                                                                mt: '1px',
                                                                                alignItems: 'center'
                                                                            }
                                                                        }]
                                                                }]
                                                        }]
                                                }, {
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    spacing: 0,
                                                    columnSize: 12,
                                                    gap: '8px',
                                                    p: 0,
                                                    elements: [{
                                                            type: FormItemTypes.ContainerItem,
                                                            name: 'customer-email',
                                                            columnSize: 12,
                                                            spacing: 0,
                                                            columnGap: 1,
                                                            alignItems: 'center',
                                                            elements: [{
                                                                    type: FormItemTypes.IconButton,
                                                                    name: '',
                                                                    columnSize: 0,
                                                                    // element: () => <MailIcon color='secondary.500' width={16} height={16} />,
                                                                    children: /*#__PURE__*/ React.createElement(MailIcon, {
                                                                        width: 16,
                                                                        height: 16
                                                                    }),
                                                                    color: 'secondary',
                                                                    sx: {
                                                                        color: 'secondary.500',
                                                                        p: 0
                                                                    }
                                                                }, {
                                                                    type: FormItemTypes.Typography,
                                                                    name: 'Email',
                                                                    value: (_crud$vehicleHistoryK23 = (_crud$vehicleHistoryK24 = crud[vehicleHistoryKeys.CustomerDetailsKey]) === null || _crud$vehicleHistoryK24 === void 0 || (_crud$vehicleHistoryK24 = _crud$vehicleHistoryK24.data) === null || _crud$vehicleHistoryK24 === void 0 || (_crud$vehicleHistoryK24 = _crud$vehicleHistoryK24.PersonContactPoint[1]) === null || _crud$vehicleHistoryK24 === void 0 ? void 0 : _crud$vehicleHistoryK24.Email) !== null && _crud$vehicleHistoryK23 !== void 0 ? _crud$vehicleHistoryK23 : '-',
                                                                    columnSize: true,
                                                                    color: 'secondary',
                                                                    // textAlign:'center',
                                                                    containerProps: {
                                                                        mt: '2px'
                                                                    }
                                                                }]
                                                        }, {
                                                            type: FormItemTypes.Box,
                                                            name: '',
                                                            display: 'flex',
                                                            columnSize: 12,
                                                            gap: '8px',
                                                            alignItems: 'start',
                                                            elements: [{
                                                                    type: FormItemTypes.IconButton,
                                                                    name: '',
                                                                    children: /*#__PURE__*/ React.createElement(LocationIcon, {
                                                                        height: 16,
                                                                        width: 16
                                                                    }),
                                                                    columnSize: 0,
                                                                    sx: {
                                                                        paddingInline: 0
                                                                    }
                                                                }, {
                                                                    type: FormItemTypes.Typography,
                                                                    name: 'Address',
                                                                    columnSize: true,
                                                                    value: "".concat((_crud$vehicleHistoryK25 = (_crud$vehicleHistoryK26 = crud[vehicleHistoryKeys.CustomerDetailsKey]) === null || _crud$vehicleHistoryK26 === void 0 || (_crud$vehicleHistoryK26 = _crud$vehicleHistoryK26.data) === null || _crud$vehicleHistoryK26 === void 0 || (_crud$vehicleHistoryK26 = _crud$vehicleHistoryK26.Address[0]) === null || _crud$vehicleHistoryK26 === void 0 ? void 0 : _crud$vehicleHistoryK26.Address1) !== null && _crud$vehicleHistoryK25 !== void 0 ? _crud$vehicleHistoryK25 : '-', " ").concat((_crud$vehicleHistoryK27 = (_crud$vehicleHistoryK28 = crud[vehicleHistoryKeys.CustomerDetailsKey]) === null || _crud$vehicleHistoryK28 === void 0 || (_crud$vehicleHistoryK28 = _crud$vehicleHistoryK28.data) === null || _crud$vehicleHistoryK28 === void 0 || (_crud$vehicleHistoryK28 = _crud$vehicleHistoryK28.Address[0]) === null || _crud$vehicleHistoryK28 === void 0 ? void 0 : _crud$vehicleHistoryK28.Address2) !== null && _crud$vehicleHistoryK27 !== void 0 ? _crud$vehicleHistoryK27 : ' '),
                                                                    color: "secondary.500",
                                                                    fontSize: 'sm',
                                                                    fontWeight: 'normal',
                                                                    marginTop: '2px'
                                                                }]
                                                        }]
                                                }]
                                        } : null]
                                }, {
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    xs: 12,
                                    sm: 6,
                                    md: 6,
                                    lg: 6,
                                    spacing: 1,
                                    elements: [{
                                            type: FormItemTypes.ContainerItem,
                                            name: 'vehicleDtails',
                                            justifyContent: 'space-between',
                                            columnSize: 12,
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    children: 'Vehicle details',
                                                    fontSize: 'sm',
                                                    fontWeight: 'medium',
                                                    color: 'text.secondary',
                                                    columnSize: 0
                                                }]
                                        }, !isOpen ? {
                                            type: FormItemTypes.CardComponent,
                                            name: '',
                                            columnSize: 12,
                                            contentProps: {
                                                justifyContent: 'space-between',
                                                spacing: 0
                                            },
                                            sx: {
                                                padding: {
                                                    xs: "16px 14px"
                                                },
                                                paddingBottom: 1.6
                                            },
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: 'RegistrationNo',
                                                    value: "".concat((_crud$vehicleHistoryK29 = (_crud$vehicleHistoryK30 = crud[vehicleHistoryKeys.InstallBaseListKey]) === null || _crud$vehicleHistoryK30 === void 0 || (_crud$vehicleHistoryK30 = _crud$vehicleHistoryK30.data) === null || _crud$vehicleHistoryK30 === void 0 || (_crud$vehicleHistoryK30 = _crud$vehicleHistoryK30.InstallBase[0]) === null || _crud$vehicleHistoryK30 === void 0 ? void 0 : _crud$vehicleHistoryK30.RegistrationNo) !== null && _crud$vehicleHistoryK29 !== void 0 ? _crud$vehicleHistoryK29 : '-'),
                                                    columnSize: 0,
                                                    fontWeight: 'medium',
                                                    fontSize: 'base',
                                                    color: 'text.primary'
                                                }, {
                                                    type: FormItemTypes.Typography,
                                                    name: 'ProductNameAndCode',
                                                    value: "".concat((_crud$vehicleHistoryK31 = (_crud$vehicleHistoryK32 = crud[vehicleHistoryKeys.InstallBaseListKey]) === null || _crud$vehicleHistoryK32 === void 0 || (_crud$vehicleHistoryK32 = _crud$vehicleHistoryK32.data) === null || _crud$vehicleHistoryK32 === void 0 || (_crud$vehicleHistoryK32 = _crud$vehicleHistoryK32.InstallBase[0]) === null || _crud$vehicleHistoryK32 === void 0 ? void 0 : _crud$vehicleHistoryK32.ProductName) !== null && _crud$vehicleHistoryK31 !== void 0 ? _crud$vehicleHistoryK31 : '-', " (").concat((_crud$vehicleHistoryK33 = (_crud$vehicleHistoryK34 = crud[vehicleHistoryKeys.InstallBaseListKey]) === null || _crud$vehicleHistoryK34 === void 0 || (_crud$vehicleHistoryK34 = _crud$vehicleHistoryK34.data) === null || _crud$vehicleHistoryK34 === void 0 || (_crud$vehicleHistoryK34 = _crud$vehicleHistoryK34.InstallBase[0]) === null || _crud$vehicleHistoryK34 === void 0 ? void 0 : _crud$vehicleHistoryK34.SKUCode) !== null && _crud$vehicleHistoryK33 !== void 0 ? _crud$vehicleHistoryK33 : '', ")"),
                                                    columnSize: 0,
                                                    fontSize: "sm",
                                                    color: 'text.secondary',
                                                    fontWeight: 'normal'
                                                }]
                                        } : null, isOpen ? {
                                            type: FormItemTypes.CardComponent,
                                            name: '',
                                            columnSize: 12,
                                            contentProps: {
                                                spacing: 0,
                                                rowGap: 1
                                            },
                                            elements: [{
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    columnSize: 12,
                                                    spacing: 0,
                                                    elements: [{
                                                            type: FormItemTypes.Typography,
                                                            name: '',
                                                            value: "".concat((_crud$vehicleHistoryK35 = (_crud$vehicleHistoryK36 = crud[vehicleHistoryKeys.InstallBaseListKey]) === null || _crud$vehicleHistoryK36 === void 0 || (_crud$vehicleHistoryK36 = _crud$vehicleHistoryK36.data) === null || _crud$vehicleHistoryK36 === void 0 || (_crud$vehicleHistoryK36 = _crud$vehicleHistoryK36.InstallBase[0]) === null || _crud$vehicleHistoryK36 === void 0 ? void 0 : _crud$vehicleHistoryK36.RegistrationNo) !== null && _crud$vehicleHistoryK35 !== void 0 ? _crud$vehicleHistoryK35 : '-'),
                                                            columnSize: 12,
                                                            fontWeight: 'medium'
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'ProductName',
                                                            value: "".concat((_crud$vehicleHistoryK37 = (_crud$vehicleHistoryK38 = crud[vehicleHistoryKeys.InstallBaseListKey]) === null || _crud$vehicleHistoryK38 === void 0 || (_crud$vehicleHistoryK38 = _crud$vehicleHistoryK38.data) === null || _crud$vehicleHistoryK38 === void 0 || (_crud$vehicleHistoryK38 = _crud$vehicleHistoryK38.InstallBase[0]) === null || _crud$vehicleHistoryK38 === void 0 ? void 0 : _crud$vehicleHistoryK38.ProductName) !== null && _crud$vehicleHistoryK37 !== void 0 ? _crud$vehicleHistoryK37 : '-', " (").concat((_crud$vehicleHistoryK39 = (_crud$vehicleHistoryK40 = crud[vehicleHistoryKeys.InstallBaseListKey]) === null || _crud$vehicleHistoryK40 === void 0 || (_crud$vehicleHistoryK40 = _crud$vehicleHistoryK40.data) === null || _crud$vehicleHistoryK40 === void 0 || (_crud$vehicleHistoryK40 = _crud$vehicleHistoryK40.InstallBase[0]) === null || _crud$vehicleHistoryK40 === void 0 ? void 0 : _crud$vehicleHistoryK40.SKUCode) !== null && _crud$vehicleHistoryK39 !== void 0 ? _crud$vehicleHistoryK39 : '', ")"),
                                                            columnSize: 12,
                                                            fontSize: "sm",
                                                            color: 'text.secondary'
                                                        }]
                                                },
                                                // {
                                                //     type: FormItemTypes.CardComponent,
                                                //     name: 'Vehicle details',
                                                //     containerProps: { spacing: 0 },
                                                //     columnSize: 12,
                                                //     sx: {
                                                //         bgcolor: "secondary.50",
                                                //         border: "none",
                                                //         px: 1.5,
                                                //         py: 1
                                                //     },
                                                //     contentProps: { spacing: 0, gap: '4px' },
                                                //     elements: [
                                                //         {
                                                //             type: FormItemTypes.Typography,
                                                //             name: 'EngineNo',
                                                //             label: 'Engine no:',
                                                //             value: `${crud[vehicleHistoryKeys.InstallBaseListKey]?.data?.InstallBase[0]?.EngineNo ?? '-'}`,
                                                //             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
                                                //             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
                                                //             fontWeight: 'medium',
                                                //             fontSize: 'sm',
                                                //             columnSize: 12,
                                                //         },
                                                //         {
                                                //             type: FormItemTypes.Typography,
                                                //             name: 'VinNo',
                                                //             label: 'Chassis no.:',
                                                //             value: `${crud[vehicleHistoryKeys.InstallBaseListKey]?.data?.InstallBase[0]?.VinNo ?? '-'}`,
                                                //             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
                                                //             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
                                                //             fontWeight: 'medium',
                                                //             fontSize: 'sm',
                                                //             columnSize: 12,
                                                //         },
                                                //         {
                                                //             type: FormItemTypes.Typography,
                                                //             name: 'SalesInvoiceDate',
                                                //             label: 'Date of sale:',
                                                //             value: crud[vehicleHistoryKeys.InstallBaseListKey]?.data?.InstallBase[0].SalesInvoiceDate
                                                //                 ? dayjs(crud[vehicleHistoryKeys.InstallBaseListKey]?.data?.InstallBase[0].SalesInvoiceDate).format('DD MMM, YYYY')
                                                //                 : '-',
                                                //             containerProps: { display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1 },
                                                //             labelTypographyProps: { mb: 0, noWrap: true, fontWeight: 'medium', fontSize: 'sm' },
                                                //             fontWeight: 'medium',
                                                //             fontSize: 'sm',
                                                //             columnSize: 12,
                                                //         },
                                                //     ]
                                                // }
                                                {
                                                    type: FormItemTypes.ContainerItem,
                                                    name: 'Vehicle details',
                                                    spacing: 0,
                                                    columnSize: 12,
                                                    p: '8px 12px',
                                                    gap: '4px',
                                                    sx: {
                                                        bgcolor: "secondary.50",
                                                        border: "none",
                                                        borderRadius: '8px'
                                                    },
                                                    elements: [{
                                                            type: FormItemTypes.Typography,
                                                            name: 'EngineNo',
                                                            label: 'Engine no:',
                                                            value: "".concat((_crud$vehicleHistoryK41 = (_crud$vehicleHistoryK42 = crud[vehicleHistoryKeys.InstallBaseListKey]) === null || _crud$vehicleHistoryK42 === void 0 || (_crud$vehicleHistoryK42 = _crud$vehicleHistoryK42.data) === null || _crud$vehicleHistoryK42 === void 0 || (_crud$vehicleHistoryK42 = _crud$vehicleHistoryK42.InstallBase[0]) === null || _crud$vehicleHistoryK42 === void 0 ? void 0 : _crud$vehicleHistoryK42.EngineNo) !== null && _crud$vehicleHistoryK41 !== void 0 ? _crud$vehicleHistoryK41 : '-'),
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'normal',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'normal',
                                                            fontSize: 'sm',
                                                            color: 'text.primary',
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'VinNo',
                                                            label: 'Chassis no.:',
                                                            value: "".concat((_crud$vehicleHistoryK43 = (_crud$vehicleHistoryK44 = crud[vehicleHistoryKeys.InstallBaseListKey]) === null || _crud$vehicleHistoryK44 === void 0 || (_crud$vehicleHistoryK44 = _crud$vehicleHistoryK44.data) === null || _crud$vehicleHistoryK44 === void 0 || (_crud$vehicleHistoryK44 = _crud$vehicleHistoryK44.InstallBase[0]) === null || _crud$vehicleHistoryK44 === void 0 ? void 0 : _crud$vehicleHistoryK44.VinNo) !== null && _crud$vehicleHistoryK43 !== void 0 ? _crud$vehicleHistoryK43 : '-'),
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'normal',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'normal',
                                                            fontSize: 'sm',
                                                            color: 'text.primary',
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'SalesInvoiceDate',
                                                            label: 'Date of sale:',
                                                            value: (_crud$vehicleHistoryK45 = crud[vehicleHistoryKeys.InstallBaseListKey]) !== null && _crud$vehicleHistoryK45 !== void 0 && (_crud$vehicleHistoryK45 = _crud$vehicleHistoryK45.data) !== null && _crud$vehicleHistoryK45 !== void 0 && _crud$vehicleHistoryK45.InstallBase[0].SalesInvoiceDate ? dayjs((_crud$vehicleHistoryK46 = crud[vehicleHistoryKeys.InstallBaseListKey]) === null || _crud$vehicleHistoryK46 === void 0 || (_crud$vehicleHistoryK46 = _crud$vehicleHistoryK46.data) === null || _crud$vehicleHistoryK46 === void 0 ? void 0 : _crud$vehicleHistoryK46.InstallBase[0].SalesInvoiceDate).format('DD MMM, YYYY') : '-',
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'normal',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'normal',
                                                            fontSize: 'sm',
                                                            color: 'text.primary',
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'NPS',
                                                            label: 'NPS:',
                                                            columnSize: 12,
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                fontWeight: 'normal'
                                                            },
                                                            containerProps: {
                                                                display: 'flex',
                                                                direction: 'row',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center'
                                                            },
                                                            setFieldProps: function (formValues) {
                                                                var _formValues$NPSRespon, _formValues$NPSRespon2;
                                                                var rating = formValues === null || formValues === void 0 || (_formValues$NPSRespon = formValues.NPSResponse) === null || _formValues$NPSRespon === void 0 || (_formValues$NPSRespon = _formValues$NPSRespon[0]) === null || _formValues$NPSRespon === void 0 ? void 0 : _formValues$NPSRespon.AnswerRating;
                                                                return {
                                                                    children: (formValues === null || formValues === void 0 || (_formValues$NPSRespon2 = formValues.NPSResponse) === null || _formValues$NPSRespon2 === void 0 ? void 0 : _formValues$NPSRespon2.length) > 0 && rating && (SELECTED_CHANNEL === null || SELECTED_CHANNEL === void 0 ? void 0 : SELECTED_CHANNEL.ChannelName) === "MC" ? /*#__PURE__*/ React.createElement(NpsChip, {
                                                                        rating: rating
                                                                    }) : '-'
                                                                };
                                                            }
                                                        }]
                                                }]
                                        } : null]
                                }]
                        }]
                }]
        }, {
            type: FormItemTypes.CardComponent,
            label: 'Job card details',
            name: 'Job Card Details',
            value: null,
            columnSize: 12,
            sx: {
                border: 'none',
                p: '0px 24px 20px 24px'
            },
            elements: [{
                    type: FormItemTypes.CardComponent,
                    label: '',
                    name: '',
                    columnSize: 12,
                    contentProps: {
                        spacing: 0
                    },
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            label: '',
                            columnSize: 12,
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            spacing: 0,
                            columnGap: '12px',
                            borderRadius: '8px',
                            bgcolor: 'secondary.50',
                            padding: '8px 12px',
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    label: '',
                                    columnSize: true,
                                    spacing: 0,
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: 'DealerName',
                                            label: 'Dealer name:',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1,
                                                spacing: 0
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm',
                                                textOverflow: 'unset',
                                                minWidth: '40%'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            sx: {
                                                textAlign: 'right'
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'BranchName',
                                            label: 'Branch:',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm',
                                                textOverflow: 'unset',
                                                minWidth: '40%'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            sx: {
                                                textAlign: 'right'
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'ServiceAdvisorName',
                                            label: ' Service advisor:',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm',
                                                textOverflow: 'unset',
                                                minWidth: '40%'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            sx: {
                                                textAlign: 'right'
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'MechanicName',
                                            label: 'Technician:',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm',
                                                textOverflow: 'unset',
                                                minWidth: '40%'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            sx: {
                                                textAlign: 'right'
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'JobType',
                                            label: 'Service type:',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm',
                                                textOverflow: 'unset',
                                                minWidth: '40%'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            sx: {
                                                textAlign: 'right'
                                            }
                                        }]
                                }, !isMobile ? {
                                    type: FormItemTypes.Divider,
                                    name: 'jabCardDivider',
                                    variant: 'fullWidth',
                                    columnSize: 0,
                                    orientation: 'vertical'
                                } : null, {
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    label: '',
                                    columnSize: true,
                                    spacing: 0,
                                    gap: '4px',
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: 'JobCard',
                                            label: 'Job card no:',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1,
                                                spacing: 0
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 100
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'DocDate',
                                            label: 'Job card date:',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            valueGetter: function (formData) {
                                                return dateFormate(formData === null || formData === void 0 ? void 0 : formData.DocDate);
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'UsageReading',
                                            label: 'Odometer reading:',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'IsOdometerChange',
                                            label: 'Odometer changed:',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            valueGetter: function (formData) {
                                                if (formData !== null && formData !== void 0 && formData.IsOdometerChange) {
                                                    var IsOdometerChange = formData !== null && formData !== void 0 && formData.IsOdometerChange ? formData === null || formData === void 0 ? void 0 : formData.IsOdometerChange : 'No';
                                                    return IsOdometerChange;
                                                }
                                                else {
                                                    return 'No';
                                                }
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'Invoices',
                                            label: 'Job card invoice(s):',
                                            containerProps: {
                                                display: 'inline-flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'baseline',
                                                gap: 1
                                            },
                                            labelTypographyProps: {
                                                mb: 0,
                                                noWrap: true,
                                                fontWeight: 'medium',
                                                fontSize: 'sm',
                                                textOverflow: 'unset',
                                                minWidth: '40%'
                                            },
                                            fontWeight: 'medium',
                                            fontSize: 'sm',
                                            columnSize: 12,
                                            valueGetter: function (formValues, field) {
                                                var invoices = formValues === null || formValues === void 0 ? void 0 : formValues.Invoices;
                                                if (!invoices)
                                                    return '';
                                                var invoiceList = invoices.split('/');
                                                var count = invoiceList.length;
                                                if (count <= 1) {
                                                    return invoices;
                                                }
                                                var firstOne = invoiceList.slice(0, 1).join('/');
                                                var remainingCount = count - 1;
                                                return "".concat(firstOne, " +...").concat(remainingCount);
                                            }
                                        }]
                                }]
                        }]
                }]
        },
        //Customer Complaints
        isMobile ? {
            type: FormItemTypes.Accordian,
            name: 'Complaints',
            label: '',
            value: null,
            sx: {
                bgcolor: 'white',
                borderLeft: 'none',
                borderRight: 'none',
                borderRadius: 0
            },
            detailPanelProps: {
                p: 2
            },
            summaryProps: {
                sx: {
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex'
                }
            },
            summary: [{
                    type: FormItemTypes.Typography,
                    name: '',
                    label: '',
                    value: null,
                    children: 'Customer Complaints',
                    columnSize: 0,
                    fontWeight: 'strong',
                    fontSize: 'lg'
                }, {
                    type: FormItemTypes.Chip,
                    name: 'CountChip',
                    columnSize: 0,
                    size: 'small',
                    variant: 'outlined',
                    color: 'info',
                    sx: {
                        ml: '8px'
                    },
                    valueGetter: function (formValues, field) {
                        var _formValues$customerC;
                        return (formValues === null || formValues === void 0 || (_formValues$customerC = formValues.customerComplaints) === null || _formValues$customerC === void 0 ? void 0 : _formValues$customerC.length) || 0;
                    }
                }],
            elements: [{
                    type: FormItemTypes.Divider,
                    name: '',
                    columnSize: 12,
                    variant: 'fullWidth'
                }, {
                    type: FormItemTypes.List,
                    name: 'customerComplaints',
                    columnSize: 12,
                    value: null,
                    variant: 'expanded',
                    getRowHeight: function () { return 'auto'; },
                    disableDetailsPanel: true,
                    disableCheckboxSelection: true,
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            label: '',
                            spacing: 0,
                            // display: 'flex',
                            // flexDirection: 'row',
                            // justifyContent: 'space-between',
                            columnSize: 12,
                            bgcolor: 'secondary.50',
                            border: '1px solid',
                            borderColor: 'secondary.200',
                            borderRadius: '8px',
                            // alignItems: 'center',
                            padding: '10px',
                            elements: [{
                                    type: FormItemTypes.Box,
                                    name: '',
                                    label: '',
                                    value: null,
                                    columnSize: 12,
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'start',
                                    alignItems: 'end',
                                    gap: '9px',
                                    elements: [{
                                            type: FormItemTypes.Icon,
                                            name: '',
                                            children: /*#__PURE__*/ React.createElement(CalanderIconSVG, null),
                                            columnSize: 0,
                                            sx: {
                                                paddingInline: 0,
                                                fontSize: 16,
                                                display: 'flex'
                                                // paddingTop: '5px'
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'DocDate',
                                            label: '',
                                            value: null,
                                            columnSize: 0,
                                            fontSize: 'base',
                                            valueGetter: function (formData) {
                                                return dateFormate(formData === null || formData === void 0 ? void 0 : formData.DocDate);
                                            }
                                        }]
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'Complaint',
                                    label: '',
                                    value: null,
                                    columnSize: 12,
                                    fontSize: 'base',
                                    color: 'text.primary',
                                    sx: {
                                        wordWrap: 'break-word',
                                        wordBreak: 'break-word',
                                        overflowWrap: 'break-word',
                                        whiteSpace: 'normal',
                                        maxWidth: '100%',
                                        overflow: 'hidden',
                                        paddingTop: '4px'
                                    }
                                }]
                        }]
                }],
            columnSize: 12
        } : {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            p: '0px 24px 20px 24px',
            elements: [{
                    type: FormItemTypes.Accordian,
                    name: '',
                    columnSize: 12,
                    value: true,
                    summaryProps: {
                        sx: {
                            display: 'flex',
                            flexDirection: 'row-reverse',
                            gap: '16px',
                            px: 3
                        }
                    },
                    summary: [{
                            type: FormItemTypes.Typography,
                            name: 'customer-complaints',
                            columnSize: 0,
                            children: /*#__PURE__*/ React.createElement(Box, {
                                display: "flex",
                                alignItems: "center"
                            }, /*#__PURE__*/ React.createElement(Typography, {
                                fontWeight: "strong",
                                fontSize: "base"
                            }, "Customer Complaints"))
                        }, {
                            type: FormItemTypes.Chip,
                            name: 'CountChip',
                            columnSize: 0,
                            size: 'small',
                            variant: 'outlined',
                            color: 'info',
                            valueGetter: function (formValues, field) {
                                var _formValues$customerC2;
                                return (formValues === null || formValues === void 0 || (_formValues$customerC2 = formValues.customerComplaints) === null || _formValues$customerC2 === void 0 ? void 0 : _formValues$customerC2.length) || 0;
                            },
                            sx: {
                                ml: '8px'
                            }
                        }],
                    elements: [{
                            type: FormItemTypes.List,
                            name: 'customerComplaints',
                            columnSize: 12,
                            value: null,
                            variant: 'expanded',
                            getRowHeight: function () { return 'auto'; },
                            disableDetailsPanel: true,
                            disableCheckboxSelection: true,
                            sx: {
                                margin: '10px'
                            },
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    label: '',
                                    spacing: 0,
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    columnSize: 12,
                                    bgcolor: 'secondary.50',
                                    border: '1px solid',
                                    borderColor: 'secondary.200',
                                    borderRadius: '8px',
                                    alignItems: 'center',
                                    padding: '10px',
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: 'Complaint',
                                            label: '',
                                            value: null,
                                            columnSize: 0,
                                            fontSize: 'base',
                                            color: 'text.primary'
                                        }, {
                                            type: FormItemTypes.Box,
                                            name: '',
                                            label: '',
                                            value: null,
                                            columnSize: 6,
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'end',
                                            alignItems: 'center',
                                            elements: [{
                                                    type: FormItemTypes.Icon,
                                                    name: '',
                                                    children: /*#__PURE__*/ React.createElement(CalanderIconSVG, null),
                                                    columnSize: 0,
                                                    sx: {
                                                        paddingInline: 0,
                                                        paddingTop: '5px'
                                                    }
                                                }, {
                                                    type: FormItemTypes.Typography,
                                                    name: 'DocDate',
                                                    label: '',
                                                    value: null,
                                                    columnSize: 0,
                                                    fontSize: 'base',
                                                    valueGetter: function (formData) {
                                                        return dateFormate(formData === null || formData === void 0 ? void 0 : formData.DocDate);
                                                    }
                                                }]
                                        }]
                                }]
                        }]
                }]
        },
        //Parts Details
        isMobile ? {
            type: FormItemTypes.Accordian,
            name: 'jCSpare',
            label: '',
            value: null,
            sx: {
                bgcolor: 'white',
                borderLeft: 'none',
                borderRight: 'none',
                borderRadius: 0
            },
            detailPanelProps: {
                p: 2
            },
            summaryProps: {
                sx: {
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex'
                }
            },
            summary: [{
                    type: FormItemTypes.Typography,
                    name: 'JCSpare',
                    label: '',
                    value: null,
                    children: 'Parts details',
                    columnSize: 0,
                    fontWeight: 'strong',
                    fontSize: 'lg'
                }, {
                    type: FormItemTypes.Chip,
                    name: '',
                    columnSize: true,
                    size: 'small',
                    variant: 'outlined',
                    color: 'info',
                    valueGetter: function (formValues, field) {
                        var _formValues$partDetai;
                        return (formValues === null || formValues === void 0 || (_formValues$partDetai = formValues.partDetails) === null || _formValues$partDetai === void 0 ? void 0 : _formValues$partDetai.length) || 0;
                    },
                    setFieldProps: function (formValues, currValue) {
                        var _formValues$partDetai2, _formValues$partDetai3;
                        // console.log("formValues",formValues?.)
                        return {
                            type: FormItemTypes.Chip,
                            sx: {
                                display: ((_formValues$partDetai2 = formValues === null || formValues === void 0 || (_formValues$partDetai3 = formValues.partDetails) === null || _formValues$partDetai3 === void 0 ? void 0 : _formValues$partDetai3.length) !== null && _formValues$partDetai2 !== void 0 ? _formValues$partDetai2 : 0) > 0 ? 'inline-flex' : 'none',
                                ml: '8px'
                            }
                        };
                    }
                }, {
                    type: FormItemTypes.Typography,
                    name: 'totalPartAmounts',
                    columnSize: 0,
                    value: null,
                    sx: {
                        pr: '12px'
                    },
                    fontWeight: 'medium',
                    containerProps: {
                        display: 'flex'
                    },
                    valueGetter: function (formValues, field) {
                        var _formValues$partDetai4, _formValues$partDetai5;
                        var totalPartAmount = (_formValues$partDetai4 = formValues === null || formValues === void 0 || (_formValues$partDetai5 = formValues.partDetails) === null || _formValues$partDetai5 === void 0 ? void 0 : _formValues$partDetai5.reduce(function (sum, item) {
                            var amount = typeof (item === null || item === void 0 ? void 0 : item.Amount) === 'number' ? item.Amount : parseFloat((item === null || item === void 0 ? void 0 : item.Amount) || '0');
                            return sum + (isNaN(amount) ? 0 : amount);
                        }, 0)) !== null && _formValues$partDetai4 !== void 0 ? _formValues$partDetai4 : 0;
                        var formattedAmount = new Intl.NumberFormat('en-IN', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        }).format(totalPartAmount);
                        return "\u20B9 ".concat(totalPartAmount.toFixed(2));
                    }
                }],
            elements: [{
                    type: FormItemTypes.Divider,
                    name: '',
                    columnSize: 12,
                    variant: 'fullWidth'
                }, {
                    type: FormItemTypes.List,
                    name: 'partDetails',
                    columnSize: 12,
                    value: null,
                    variant: 'compact',
                    disableCheckboxSelection: true,
                    // sx: {
                    //     border: '1px solid',
                    //     borderColor: 'secondary.200',
                    //     borderCollapse: 'collapse'
                    // },
                    cellStyles: {
                        bgcolor: "secondary.50",
                        borderTop: '1px solid',
                        borderBottom: '1px solid',
                        borderColor: 'secondary.200',
                        borderCollapse: 'collapse'
                    },
                    columns: [{
                            field: '',
                            flex: 1,
                            renderCell: function (params) {
                                var _params$row, _params$row2, _params$row3;
                                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                                    sx: {
                                        fontSize: 'sm',
                                        fontWeight: 'ormal',
                                        color: 'text.primary'
                                    }
                                }, params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.ItemName), /*#__PURE__*/ React.createElement(Typography, {
                                    sx: {
                                        fontSize: 'sm',
                                        fontWeight: 'ormal',
                                        color: 'text.tertiary'
                                    }
                                }, params !== null && params !== void 0 && (_params$row2 = params.row) !== null && _params$row2 !== void 0 && _params$row2.ItemCode ? "#".concat(params === null || params === void 0 || (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.ItemCode) : ""));
                            }
                        }],
                    elements: partElements
                }],
            columnSize: 12
        } : {
            type: FormItemTypes.Custom,
            name: "partDetails",
            element: PartDetails,
            columnSize: 12
        },
        // Labour Details 
        isMobile ? {
            type: FormItemTypes.Accordian,
            name: 'labourDetail',
            label: '',
            value: null,
            sx: {
                bgcolor: 'white',
                borderLeft: 'none',
                borderRight: 'none',
                borderRadius: 0
            },
            detailPanelProps: {
                p: 2
            },
            summaryProps: {
                sx: {
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex'
                }
            },
            summary: [{
                    type: FormItemTypes.Typography,
                    name: 'labourDetail',
                    label: '',
                    value: null,
                    children: 'Labour details',
                    columnSize: 0,
                    fontWeight: 'strong',
                    fontSize: 'lg'
                }, {
                    type: FormItemTypes.Chip,
                    name: '',
                    columnSize: true,
                    size: 'small',
                    variant: 'outlined',
                    color: 'info',
                    valueGetter: function (formValues, field) {
                        var _formValues$labourDet;
                        return (formValues === null || formValues === void 0 || (_formValues$labourDet = formValues.labourDetails) === null || _formValues$labourDet === void 0 ? void 0 : _formValues$labourDet.length) || 0;
                    },
                    setFieldProps: function (formValues, currValue) {
                        var _formValues$labourDet2, _formValues$labourDet3;
                        return {
                            type: FormItemTypes.Chip,
                            sx: {
                                display: ((_formValues$labourDet2 = formValues === null || formValues === void 0 || (_formValues$labourDet3 = formValues.labourDetails) === null || _formValues$labourDet3 === void 0 ? void 0 : _formValues$labourDet3.length) !== null && _formValues$labourDet2 !== void 0 ? _formValues$labourDet2 : 0) > 0 ? 'inline-flex' : 'none',
                                ml: '8px'
                            }
                        };
                    }
                }, {
                    type: FormItemTypes.Typography,
                    name: 'totalLabourAmounts',
                    columnSize: 0,
                    value: null,
                    sx: {
                        pr: '12px'
                    },
                    fontWeight: 'medium',
                    containerProps: {
                        display: 'flex'
                    },
                    valueGetter: function (formValues, field) {
                        var _formValues$labourDet4, _formValues$labourDet5;
                        var totalLabourAmount = (_formValues$labourDet4 = formValues === null || formValues === void 0 || (_formValues$labourDet5 = formValues.labourDetails) === null || _formValues$labourDet5 === void 0 ? void 0 : _formValues$labourDet5.reduce(function (sum, item) {
                            var amount = typeof (item === null || item === void 0 ? void 0 : item.Amount) === 'number' ? item.Amount : parseFloat((item === null || item === void 0 ? void 0 : item.Amount) || '0');
                            return sum + (isNaN(amount) ? 0 : amount);
                        }, 0)) !== null && _formValues$labourDet4 !== void 0 ? _formValues$labourDet4 : 0;
                        var formattedAmount = new Intl.NumberFormat('en-IN', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        }).format(totalLabourAmount);
                        return "\u20B9 ".concat(totalLabourAmount.toFixed(2));
                    }
                }],
            elements: [{
                    type: FormItemTypes.Divider,
                    name: '',
                    columnSize: 12,
                    variant: 'fullWidth'
                }, {
                    type: FormItemTypes.List,
                    name: 'labourDetails',
                    columnSize: 12,
                    value: null,
                    disableCheckboxSelection: true,
                    variant: 'compact',
                    // sx: {
                    //     border: '1px solid',
                    //     borderColor: 'secondary.200',
                    //     borderCollapse: 'collapse's
                    // },
                    // cellStyles: {
                    //     bgcolor: "secondary.50",
                    //     borderColor: 'secondary.200',
                    //     borderTop: '1px solid',
                    //     borderBottom: '1px solid',
                    //     borderCollapse: 'collapse'
                    // },
                    cellStyles: {
                        bgcolor: "secondary.50",
                        borderTop: '1px solid',
                        borderBottom: '1px solid',
                        borderColor: 'secondary.200',
                        borderCollapse: 'collapse'
                    },
                    columns: [{
                            field: '',
                            flex: 1,
                            renderCell: function (params) {
                                var _params$row4, _params$row5, _params$row6;
                                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                                    sx: {
                                        fontSize: 'sm',
                                        fontWeight: 'ormal',
                                        color: 'text.primary'
                                    }
                                }, params === null || params === void 0 || (_params$row4 = params.row) === null || _params$row4 === void 0 ? void 0 : _params$row4.ItemName), /*#__PURE__*/ React.createElement(Typography, {
                                    sx: {
                                        fontSize: 'sm',
                                        fontWeight: 'ormal',
                                        color: 'text.tertiary'
                                    }
                                }, params !== null && params !== void 0 && (_params$row5 = params.row) !== null && _params$row5 !== void 0 && _params$row5.ItemCode ? "#".concat(params === null || params === void 0 || (_params$row6 = params.row) === null || _params$row6 === void 0 ? void 0 : _params$row6.ItemCode) : ""));
                            }
                        }],
                    elements: labourElements
                }],
            columnSize: 12
        } : {
            type: FormItemTypes.Custom,
            name: 'labourDetails',
            element: LabourDetails,
            columnSize: 12
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        mode: "edit",
        gridProps: {
            spacing: 0,
            paddingTop: {
                xs: 0,
                sm: 0,
                md: "70px"
            }
        },
        formData: ViewServiceHistoryDetails,
        getFormAPI: function () { return __awaiter(void 0, void 0, void 0, function () {
            var complaintsData, JCLabour, partDetails, NPSResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (crudDataForComplaints === null || crudDataForComplaints === void 0 ? void 0 : crudDataForComplaints.filter(function (it) { return (it === null || it === void 0 ? void 0 : it.ParentDocID) === (data === null || data === void 0 ? void 0 : data.DocID); }))];
                    case 1:
                        complaintsData = _a.sent();
                        return [4 /*yield*/, (crudDataForLabour === null || crudDataForLabour === void 0 ? void 0 : crudDataForLabour.filter(function (it) { return (it === null || it === void 0 ? void 0 : it.ParentDocID) === (data === null || data === void 0 ? void 0 : data.DocID); }))];
                    case 2:
                        JCLabour = _a.sent();
                        return [4 /*yield*/, (crudDataForPart === null || crudDataForPart === void 0 ? void 0 : crudDataForPart.filter(function (it) { return (it === null || it === void 0 ? void 0 : it.ParentDocID) === (data === null || data === void 0 ? void 0 : data.DocID); }))];
                    case 3:
                        partDetails = _a.sent();
                        return [4 /*yield*/, fetchNpsByChassis(data === null || data === void 0 ? void 0 : data.ChassisNo)];
                    case 4:
                        NPSResponse = _a.sent();
                        return [2 /*return*/, {
                                success: true,
                                data: _objectSpread(_objectSpread({}, data), {}, {
                                    customerComplaints: complaintsData,
                                    labourDetails: JCLabour,
                                    partDetails: partDetails,
                                    NPSResponse: NPSResponse
                                })
                            }];
                }
            });
        }); }
    }));
};
